/* FLOLAE_CARD_COLORS (2026-10-17): 상품 카드 컬러 칩 — snippets/flo-card-colors.liquid 참고.
   문서 하나에 이벤트를 걸어 무한 스크롤로 붙는 카드에도 동작한다. */
(() => {
  const CHIP = '[data-flo-cc-chip]';
  const ROW = '[data-flo-cardcolors]';

  // 상품 카드(product-card) + 최근 본 상품 카드(resource-card)
  const cardOf = (el) => el.closest('product-card') || el.closest('.product-card') || el.closest('.resource-card');
  const imgOf = (card) =>
    card &&
    (card.querySelector('.card-gallery slideshow-slide:not([hidden]) img') ||
      card.querySelector('.card-gallery img') ||
      card.querySelector('.resource-card__media img.resource-card__image:not(.resource-card__image--secondary)'));

  function show(card, src, srcset) {
    const img = imgOf(card);
    if (!img) return;
    if (!img.dataset.floCcSrc) {
      img.dataset.floCcSrc = img.getAttribute('src') || '';
      img.dataset.floCcSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('loading');
    if (srcset) img.setAttribute('srcset', srcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', src);
  }

  function showChip(chip) {
    show(cardOf(chip), chip.dataset.src, chip.dataset.srcset);
  }

  // 마우스가 칩 줄을 벗어나면: 선택된 칩 사진, 없으면 원래 사진
  function restore(row) {
    const card = cardOf(row);
    const picked = row.querySelector(CHIP + '[aria-pressed="true"]');
    if (picked) return showChip(picked);
    const img = imgOf(card);
    if (img && img.dataset.floCcSrc) show(card, img.dataset.floCcSrc, img.dataset.floCcSrcset);
  }

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse' || !(e.target instanceof Element)) return;
    const chip = e.target.closest(CHIP);
    if (chip) showChip(chip);
  });

  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse' || !(e.target instanceof Element)) return;
    const row = e.target.closest(ROW);
    if (!row) return;
    if (e.relatedTarget instanceof Node && row.contains(e.relatedTarget)) return;
    restore(row);
  });

  // FLOLAE_CARD_COLOR_SYNC (2026-10-19): 컬렉션 컬러 필터로 서버가 고른 컬러(data-flo-sync-url)에 카드 링크 3개를 맞춘다(무한 스크롤로 붙는 카드 포함)
  function syncLinks(root) {
    (root || document).querySelectorAll(ROW + '[data-flo-sync-url]:not([data-flo-synced])').forEach((row) => {
      row.setAttribute('data-flo-synced', '1');
      const card = cardOf(row);
      if (!card) return;
      card.querySelectorAll('a.product-card__link, a[ref="cardGalleryLink"], a[ref="productTitleLink"]').forEach((a) => a.setAttribute('href', row.dataset.floSyncUrl));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => syncLinks());
  else syncLinks();
  new MutationObserver((muts) => {
    for (const m of muts) for (const n of m.addedNodes) if (n instanceof Element) syncLinks(n);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // 클릭·터치 = 그 컬러 선택(사진만 바꾸고 이동 없음). 카드 링크는 그 컬러 변형 주소로.
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;
    const chip = e.target.closest(CHIP);
    if (!chip) return;
    e.preventDefault();
    const row = chip.closest(ROW);
    row.querySelectorAll(CHIP).forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
    showChip(chip);
    const card = cardOf(chip);
    const url = chip.dataset.url;
    if (card && url) {
      card.querySelectorAll('a.product-card__link, a[ref="cardGalleryLink"], a[ref="productTitleLink"], a.resource-card__link').forEach((a) => {
        a.setAttribute('href', url);
      });
    }
  });
})();
